import type { HTMLAttributes } from "react";
import styled from "styled-components";
import { copyFooterData } from "./copyFooterData";

export const CopyFooter = styled(function ({
  className,
}: Omit<HTMLAttributes<HTMLDivElement>, "children">) {
  const { year, appVersion } = copyFooterData;
  return (
    <footer className={className}>
      <p>
        &copy; {year} NAF v{appVersion}
      </p>
    </footer>
  );
})`
  p {
    margin: 0;
    background-color: white;
    padding: 0.5em 1em;
    ${({ theme }) => theme.fontStyle.bodyText.tiny};
  }
`;
